import { LogDataAttributeType } from './types';

export const BUSINESS_LOG_STATUS_VALUES = [
  {
    value: 'OK',
  },
  {
    value: 'Info',
  },
  {
    value: 'Hoiatus',
  },
  {
    value: 'Viga',
  },
  {
    value: 'Tehniline viga',
  },
];

export const generateId = (() => {
  let idInc = 0;
  return () => {
    return ['uid', ++idInc].join('-');
  };
})();

export function serializeLogDataFilters(values: LogDataAttributeType[]) {
  const filter: Record<string, string[]> = {};
  values.forEach(({ attribute, value }) => {
    const filterValue = filter[attribute] ?? [];
    if (attribute || value) {
      filter[attribute ?? ''] = [...filterValue, value ?? ''];
    }
  });
  return Object.keys(filter).length === 0 ? '' : JSON.stringify(filter);
}

export function deserializeLogDataFilters(
  filter?: string,
): LogDataAttributeType[] {
  const filters: LogDataAttributeType[] = [];

  const filterObject: Record<string, string[]> = JSON.parse(filter ?? '{}');
  Object.entries(filterObject).forEach(([attribute, values]) =>
    values.forEach((value) =>
      filters.push({
        attribute,
        id: generateId(),
        value,
      }),
    ),
  );

  return filters;
}

export function splitTraceIdFilter(filter?: string) {
  const filterObject: Record<string, string[]> = JSON.parse(filter ?? '{}');
  const { traceId: traceIds = [], ...logDataFilters } = filterObject;
  const traceId = traceIds.find(Boolean);

  return {
    logData:
      Object.keys(logDataFilters).length === 0
        ? undefined
        : JSON.stringify(logDataFilters),
    traceId,
    hasSharedTraceId:
      !traceId && Object.hasOwn(filterObject, 'traceId') ? true : undefined,
  };
}

export function mergeTraceIdFilter(
  filter?: string,
  traceId?: string,
  hasSharedTraceId?: boolean | string,
) {
  const filterObject: Record<string, string[]> = JSON.parse(filter ?? '{}');

  if (traceId) {
    filterObject.traceId = [traceId];
  } else if (hasSharedTraceId === true || hasSharedTraceId === 'true') {
    filterObject.traceId = [''];
  } else {
    delete filterObject.traceId;
  }

  return Object.keys(filterObject).length === 0
    ? ''
    : JSON.stringify(filterObject);
}

// TODO calculationStartTime and validationStartTime classifiers to be checked,
//  attribute code and name contradictory:
//  calculationStartTime: Arvutamise staatus
//  validationStartTime: Valideerimise staatus
const STATUS_ATTRIBUTES = new Set([
  'status',
  'calculationStartTime',
  'validationStartTime',
  'queryStatus',
]);

export function isStatusField(key: string, attribute: string) {
  return key === 'logData2' && STATUS_ATTRIBUTES.has(attribute);
}

export const EMPTY_FILTER: LogDataAttributeType = {
  id: generateId(),
  attribute: '',
  value: '',
};
